<!-- ################# SITE ################## -->

<!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-197991674-2"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-197991674-2');
    </script>

<!-- bootstrap core css -->

<style src="../../assets/site/css/font-awesome.min.css"></style>
<style src="../../assets/site/css/themify-icons.css"></style>
<style src="../../assets/site/css/magnific-popup.css"></style>
<style src="../../assets/site/css/owl.theme.default.min.css"></style>
<style src="../../assets/site/css/owl.carousel.min.css"></style>
<style src="../../assets/site/css/bootstrap.min.css"></style>
<style src="../../assets/site/css/style.css"></style>
<style src="../../assets/site/css/responsive.css"></style>
<script src="../../assets/site/js/vendor/modernizr-2.8.1.min.js"></script>


    <!-- HTML5 Shim and Respond.js for IE8 support of HTML5 elements and media queries -->
    <!-- WARNING: Respond.js doesn't work if you view the page via file:// -->
    <!--[if lt IE 9]>
    <script src="js/vendor/html5shim.js"></script>
    <script src="js/vendor/respond.min.js"></script>
    <![endif]-->
<!-- ################# SITE ################## -->


    

<template>
<div id="main" class="main-content-wraper">
    <a href="https://api.whatsapp.com/send?phone=5511957787843" target="_blank" class="whatsapp"><img src="@/assets/ic-whatsapp.png" alt="Contato via Whatsapp"></a>
    <img class="loading" />
     <div class="custom-modal">
            <div class="shadow"></div>
            <a class="fechar">X</a>
            <div class="video-container col-12 col-md-10 col-lg-8">
                <div class="content">
                    <a class="logo-bb-modal" href="/site">
                        <img src="@/assets/site/img/bertone-broker-logo.png" alt="logo">
                    </a>
                    <div class="content-white">
                        <h3>{{nome}}, obrigado pelo contato!</h3>
                        <p>Ligaremos o mais breve possível na parte da {{periodo}}.</p><br /><br />
                        <p>Se preferir antecipar o contato, também estamos disponíveis no número <a href="https://api.whatsapp.com/send?phone=5511957787843" target="_blank">(11) 9 5778-7843</a> | Ligações e WhatsApp).</p>
                    </div>
                </div>
            </div>
        </div>
            <!-- Preloader -->
            <!-- <div id="preloader">
                <div id="loader"></div>
            </div> -->
            <!--end preloader-->
            <!-- <div class="custom-modal custom-modal-corona">
                <div class="shadow"></div>
                <a class="fechar">X</a>
                <div class="video-container col-12 col-md-10 col-lg-8" style="z-index:3">
                    <div class="content">
                        <div style="background:#fff" class="video-youtube">
                            
                            <img style="width:100%" src="@/assets/banner-covid19.jpg" alt="AVISO - COVID-19 | Suspensão de cobranças" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-modal custom-modal-ios">
                <div class="shadow"></div>
                <a class="fechar">X</a>
                <div class="video-container col-12 col-md-10 col-lg-8" style="z-index:3">
                    <div class="content">
                        <div style="background:#fff" class="video-youtube">
                            <h5>Download do aplicativo no IOS</h5>
                            <img src="@/assets/baixar-app-ios.gif" alt="Baixar app no IOS" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-modal">
                <div class="shadow"></div>
                <a class="fechar">X</a>
                <div class="video-container col-12 col-md-10 col-lg-8">
                    <div class="content">
                        
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/DLtee_hMVsg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div> -->
            
                
            
            <div class="main-content-inner">

                <!--start header section-->
                <header class="header">
                    <!--start navbar-->
                    <div class="navbar navbar-default navbar-fixed-top">
                        <div class="container">
                            <div class="row">
                                <div class="navbar-header page-scroll">
                                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                                            data-target="#myNavbar">
                                        <span class="sr-only">Toggle navigation</span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                    </button>
                                    <a class="navbar-brand page-scroll logo-bb" href="/site">
                                        <img src="@/assets/site/img/bertone-broker-logo.png" alt="logo">
                                    </a>
                                </div>

                                <!-- Collect the nav links, forms, and other content for toggling -->
                                <div class="navbar-collapse collapse" id="myNavbar">
                                    
                                    <ul class="nav navbar-nav navbar-right" style="margin-right: 0 !important">
                                        
                                        <li><a class="page-scroll bt-lancamentos" href="#lancamentos">Lançamentos</a></li>
                                        <li><a class="page-scroll bt-contato" href="#contato">Contato</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!--end navbar-->
                </header>
                <!--end header section-->

                <!--start hero section-->
                <v-container fluid class="home-hero">
                    <v-layout justify-center align-center column pa-5>
                        <div class="display-4 font-weight-black white--text text-xs-center">PRINCIPAIS LANÇAMENTOS</div>
                        <div class="display-4 font-weight-black white--text text-xs-center mb-3">EM SÃO PAULO</div>
                        <!-- <div class="display-1 font-weight-bold white--text text-xs-center"><span>Os melhores imóveis, de todos os tamanhos e valores, nas principais localizações de São Paulo.</span></div> -->
                        <v-btn fab class="mt-5 brown darken-4">
                        <a class="link-ancora" href="#lancamentos"><v-icon large color="white">expand_more</v-icon></a>
                        </v-btn>
                    </v-layout>
                    <div class="redes-sociais">
                        <a href="https://api.whatsapp.com/send?phone=5511957787843" target="_blank">
                            <img src="data:image/png;base64,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" />
                        </a>
                        <a href="https://www.instagram.com/bertonebroker/" target="_blank"><img src="data:image/png;base64,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" /></a>
                        <a href="https://www.facebook.com/bertonebroker/" target="_blank"><img src="data:image/png;base64,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" /></a>
                    </div>
                </v-container>
                <!--end hero section-->

                <!--start lançamentos section-->
                <v-container grid-list-lg id="lancamentos">
                    <br /><br /><br />
                    <v-layout row>
                        <v-flex xs12 class="text-xs-center display-1 font-weight-black my-5">Lançamentos</v-flex>
                    </v-layout>
                    <v-layout row wrap class="meal-plans">

                        <v-flex xs12 sm12 md4>
                            <a href="lasar-chacara-klabin">
                                <v-card>
                                    <v-responsive>
                                        <v-img :src="img7" height="500px">
                                            <v-container fill-height fluid>
                                                <v-layout fill-height>
                                                    <v-flex xs12 align-end flexbox>
                                                        <!-- <span class="headline white--text">KETO</span> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-img>
                                    </v-responsive>

                                    <v-card-text>
                                        <div>
                                            <h3 class="headline mb-0">Um ponto de vista único do seu jeito de viver. Lasar Chácara klabin.</h3>
                                            <div>Lasar Autoral é um empreendimento com arquitetura diferenciada, amplitude de espaços e todas as unidades voltada à Praça Kant.
                                                <br /><br />
                                                    <b>Projetado para trazer à Chácara Klabin valorização, modernidade e arte.</b>
                                            </div>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions v-if="['menu'].includes($route.name)">
                                        <v-btn outline block color="green" @click="showRecipes('keto')" data-cy="plansKetoBtn">
                                            Select This Plan</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-flex>

                        <v-flex xs12 sm12 md4>
                            <a href="living-heredita-alto-do-ipiranga">
                                <v-card>
                                    <v-responsive>
                                        <v-img :src="img6" height="500px">
                                            <v-container fill-height fluid>
                                                <v-layout fill-height>
                                                    <v-flex xs12 align-end flexbox>
                                                        <!-- <span class="headline white--text">KETO</span> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-img>
                                    </v-responsive>

                                    <v-card-text>
                                        <div>
                                            <h3 class="headline mb-0">Um legado para gerações. História e Futuro acontecendo ao mesmo tempo.</h3>
                                            <div>Morar na rua Marquês de Olinda é ter a certeza que você está no melhor do Alto do Ipiranga.
                                                <br /><br />
                                                    <b>Charme e modernidade morando na mesma rua.</b>
                                            </div>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions v-if="['menu'].includes($route.name)">
                                        <v-btn outline block color="green" @click="showRecipes('keto')" data-cy="plansKetoBtn">
                                            Select This Plan</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-flex>

                        <v-flex xs12 sm12 md4>
                            <a href="living-villaggio-tatuape">
                                <v-card>
                                    <v-responsive>
                                        <v-img :src="img5" height="500px">
                                            <v-container fill-height fluid>
                                                <v-layout fill-height>
                                                    <v-flex xs12 align-end flexbox>
                                                        <!-- <span class="headline white--text">PALEO</span> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-img>
                                    </v-responsive>

                                    <v-card-text>
                                        <div>
                                            <h3 class="headline mb-0">A sofisticação, o charme e o clima intimista da região da Toscana</h3>
                                            <div>                                                
                                                Imagine morar em um condomínio com todo o charme de uma Vila da Toscana - Itália<br /><br />
                                                    <b>Um dos bairros mais tradicionais de São Paulo, em um mundo intimista e completo como você nunca viu!.</b>

                                            </div>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions v-if="['menu'].includes($route.name)">
                                        <v-btn outline block color="green" @click="showRecipes('paleo')" data-cy="plansPaleoBtn">
                                            Select This Plan</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-flex>
                        
                        

                        

                        

                    </v-layout>
                </v-container>
                <!--end lançamentos section-->

                <!--start outros empreendimentos section-->
                <v-container grid-list-lg id="lancamentos">
                    <br /><br /><br />
                    <v-layout row>
                        <v-flex xs12 class="text-xs-center display-1 font-weight-black my-5">Outros Empreendimentos</v-flex>
                    </v-layout>
                    <v-layout row wrap class="meal-plans">

                        <v-flex xs12 sm12 md4>
                            <a href="grand-home-helbor">
                                <v-card>
                                    <v-responsive>
                                        <v-img :src="img2" height="500px">
                                            <v-container fill-height fluid>
                                                <v-layout fill-height>
                                                    <v-flex xs12 align-end flexbox>
                                                        <!-- <span class="headline white--text">PALEO</span> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-img>
                                    </v-responsive>

                                    <v-card-text>
                                        <div>
                                            <h3 class="headline mb-0">A um elevador de distância um Super Mall espera por você.</h3>
                                            <div>Aqui, tudo o que você sempre quis está dentro do seu apartamento, do condomínio
                                                e no bairro. <br /><br />Um super mall exclusivo com 4 salas de cinema Cinépolis, uma
                                                megaloja Decathlon e mais lojas e serviços a apenas um elevador de distância.

                                                <br /><br />
                                                    <b>Supermall ComVem lojas no térreo.</b>
                                            </div>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions v-if="['menu'].includes($route.name)">
                                        <v-btn outline block color="green" @click="showRecipes('paleo')" data-cy="plansPaleoBtn">
                                            Select This Plan</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-flex>

                        <v-flex xs12 sm12 md4>
                            <a href="parque-global">
                                <v-card>
                                    <v-responsive>
                                        <v-img :src="img4" height="500px">
                                            <v-container fill-height fluid>
                                                <v-layout fill-height>
                                                    <v-flex xs12 align-end flexbox>
                                                        <!-- <span class="headline white--text">PALEO</span> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-img>
                                    </v-responsive>

                                    <v-card-text>
                                        <div>
                                            <h3 class="headline mb-0">Um projeto inspirado em referências mundiais.</h3>
                                            <div>Viver no Parque Global é sinônimo de comodidade em seu mais alto teor de estilo.<br /><br />
                                                    Com  shopping center, complexo de inovação, saúde e educação a uma caminhada de distância, esse é um bairro completo
                                                    que respira qualidade de vida.<br /><br />
                                                    <b>É o maior e mais moderno empreendimento que São Paulo já viu.</b>

                                            </div>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions v-if="['menu'].includes($route.name)">
                                        <v-btn outline block color="green" @click="showRecipes('paleo')" data-cy="plansPaleoBtn">
                                            Select This Plan</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-flex>
                        
                        <v-flex xs12 sm12 md4>
                            <a href="grand-home-helbor">
                                <v-card>
                                    <v-responsive>
                                        <v-img :src="img2" height="500px">
                                            <v-container fill-height fluid>
                                                <v-layout fill-height>
                                                    <v-flex xs12 align-end flexbox>
                                                        <!-- <span class="headline white--text">PALEO</span> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-img>
                                    </v-responsive>

                                    <v-card-text>
                                        <div>
                                            <h3 class="headline mb-0">A um elevador de distância um Super Mall espera por você.</h3>
                                            <div>Aqui, tudo o que você sempre quis está dentro do seu apartamento, do condomínio
                                                e no bairro. <br /><br />Um super mall exclusivo com 4 salas de cinema Cinépolis, uma
                                                megaloja Decathlon e mais lojas e serviços a apenas um elevador de distância.

                                                <br /><br />
                                                    <b>Supermall ComVem lojas no térreo.</b>
                                            </div>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions v-if="['menu'].includes($route.name)">
                                        <v-btn outline block color="green" @click="showRecipes('paleo')" data-cy="plansPaleoBtn">
                                            Select This Plan</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-flex>

                        <v-flex xs12 sm12 md4>
                            <a href="smart-home-nova-klabin">
                                <v-card>
                                    <v-responsive>
                                        <v-img :src="img1" height="500px">
                                            <v-container fill-height fluid>
                                                <v-layout fill-height>
                                                    <v-flex xs12 align-end flexbox>
                                                        <!-- <span class="headline white--text">KETO</span> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-img>
                                    </v-responsive>

                                    <v-card-text>
                                        <div>
                                            <h3 class="headline mb-0">A 400 metros do metrô Santos-Imigrantes.</h3>
                                            <div>Ser Smart é morar em um apartamento que facilita sua vida, perto do metrô, com ótimo espaço na varanda e com lazer na medida para o que você realmente precisa.
                                                <br /><br />
                                                    <b>A sua escolha inteligente.</b>
                                            </div>
                                        </div>
                                    </v-card-text>

                                    <v-card-actions v-if="['menu'].includes($route.name)">
                                        <v-btn outline block color="green" @click="showRecipes('keto')" data-cy="plansKetoBtn">
                                            Select This Plan</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-flex>

                        

                    </v-layout>
                </v-container>
                <!--end outros empreendimentos section-->

                <!--start contato section-->
                <br /><br /><br /><br /><br /><br />
                <v-container fluid class="brown lighten-4" style="width:100% !important" id="contato">
                    <br /><br /><br />
                    <v-container grid-list-lg>
                        <v-layout column>
                            <v-flex  class="display-2 font-weight-black brown--text text-xs-center my-5">Contato</v-flex>
                            <v-flex>
                                <!-- <div class="headline mt-3 brown--text font-weight-bold">Lorem ipsum</div> -->
                                <p class="subheading mt-3">Além dos lançamentos do site, temos outros empreendimentos de acordo com o seu perfil.<br /><br />Fale com um especialista para ajuda-lo(a) na busca do imóvel ideal.</p>
                            </v-flex>
                            <v-layout row wrap class="meal-plans">
                                <v-flex xs12 sm12 md6>
                                    <v-card>
                                        <v-card-text>
                                            <div>
                                                <h3 class="headline mb-0">Formulário</h3>
                                                <div>
                                                    <form data-v-782fbf81="" action="php/mail.php" method="POST" id="contactForm1" novalidate="novalidate" class="contact-us-form">
                                                        <br /><h5 data-v-782fbf81="">Deixe que nós ligamos para você!</h5>
                                                        <v-layout row wrap>
                                                        
                                                            <div data-v-782fbf81="" class="col-sm-8 col-xs-12">
                                                                <div data-v-782fbf81="" class="form-group">
                                                                    <input v-model="nome" data-v-782fbf81="" type="text" name="name" placeholder="Nome" required="required" class="form-control">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-4 col-xs-12">
                                                                <div class="form-group">
                                                                    <input v-model="telefone" v-mask="mask" type="text" name="phone" value="" id="phone" placeholder="Celular" class="form-control">
                                                                </div>
                                                            </div>
                                                            <div data-v-782fbf81="" class="col-sm-8 col-xs-12">
                                                                <div data-v-782fbf81="" class="form-group">
                                                                    <input v-model="email" data-v-782fbf81="" type="email" name="email" placeholder="E-mail" required="required" class="form-control">
                                                                </div>
                                                            </div>
                                                            <div data-v-782fbf81="" class="col-sm-4 col-xs-12">
                                                                <div data-v-782fbf81="" class="form-group input-field">
                                                                    <select class="select form-select" @change="selectPeriodo($event)">
                                                                        <option value="selecione">Período do contato</option>
                                                                        <option value="manha">Manhã</option>
                                                                        <option value="tarde">Tarde</option>
                                                                        <option value="noite">Noite</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div data-v-782fbf81="" class="col-sm-12 col-xs-12">
                                                                <div data-v-782fbf81="" class="form-group">
                                                                    <button data-v-782fbf81="" type="button" class="pull-right v-btn theme--light primary" data-cy="joinSubmitBtn"><div class="v-btn__content" @click="enviarDados()">Enviar</div></button>
                                                                </div>
                                                            </div>
                                                        </v-layout>
                                                        
                                                        
                                                        <br /><br />

                                                        


                                                    </form>
                                                </div>
                                            </div>
                                        </v-card-text>

                                        <v-card-actions v-if="['menu'].includes($route.name)">
                                            <v-btn outline block color="green" @click="showRecipes('keto')" data-cy="plansKetoBtn">
                                                Select This Plan</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 sm12 md6>
                                    <v-card>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <h3 class="headline mb-0">Outros contatos</h3>
                                                </v-flex>
                                                <v-flex xs6 sm6 md6 class="somente-desktop">
                                                    
                                                    <img class="qr-code" src="../../assets/qr-code.jpg" />
                                                    

                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    
                                                    

                                                    <div class="horario-atendimento">
                                                        <a class="telefone" href="tel:11957787843">(11) 95778-7843</a>
                                                        <a class="email" mailto="bertonebroker@gmail.com">bertonebroker@gmail.com</a>
                                                        <div class="redes-sociais redes-sociais-contato">
                                                            <a href="https://api.whatsapp.com/send?phone=5511957787843" target="_blank">
                                                                <img src="data:image/png;base64,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" />
                                                            </a>
                                                            <a href="https://www.instagram.com/bertonebroker/" target="_blank"><img src="data:image/png;base64,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" /></a>
                                                            <a href="https://www.facebook.com/bertonebroker/" target="_blank"><img src="data:image/png;base64,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" /></a>
                                                        </div>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>

                                        <v-card-actions v-if="['menu'].includes($route.name)">
                                            <v-btn outline block color="green" @click="showRecipes('paleo')" data-cy="plansPaleoBtn">
                                                Select This Plan</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>

                            </v-layout>
                            <!-- <v-flex>
                                <div class="headline mt-3 brown--text font-weight-bold">Lorem ipsum</div>
                                <p class="subheading mt-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras pulvinar risus quis mauris interdum, in euismod nibh pretium. Etiam pulvinar tincidunt dapibus. Quisque sollicitudin, mauris a consequat consectetur, turpis nisl sollicitudin enim, id consectetur neque neque nec metus. Pellentesque dolor nisi, vulputate quis lobortis ac, tincidunt et quam. Mauris pulvinar blandit nisi nec mattis. Aliquam accumsan ut sem eget efficitur. Vivamus in tortor gravida eros laoreet condimentum nec vel dui. Nullam quam massa, ultrices eget tincidunt a, pulvinar ac libero.</p>

                                <p class="subheading mt-3">Nullam nec massa eu est fringilla lobortis. Praesent in enim in justo blandit varius. Cras placerat arcu in sapien rhoncus aliquet. Sed interdum tortor et tincidunt condimentum. Etiam consequat mi leo, in suscipit odio scelerisque molestie. Nam et purus consequat, iaculis augue vel, sagittis ligula. Vestibulum aliquet vulputate erat. Phasellus id mauris mauris. Nunc a maximus dolor. Curabitur ut vestibulum arcu. Curabitur non lacus justo. Cras varius a magna in semper. Nulla eros ante, consectetur faucibus sapien eu, rhoncus imperdiet dui. Sed viverra iaculis nunc, id pulvinar massa egestas vitae.</p>

                                <p class="subheading mt-3">Aenean erat metus, imperdiet eget nisl laoreet, venenatis ultricies ante. In interdum ante vel dictum ullamcorper. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer sit amet gravida diam. Aliquam in tempor metus. Fusce pellentesque pharetra sem, et luctus justo tempor dictum. Ut feugiat est sed tristique egestas. Nullam posuere a nunc in blandit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Suspendisse laoreet ultrices eros, nec malesuada enim semper sit amet. Maecenas efficitur consectetur accumsan. Etiam in aliquam turpis, ut pharetra nulla. Vestibulum malesuada, nulla id elementum cursus, nibh dui rhoncus felis, suscipit mattis felis enim sed ex. Pellentesque scelerisque aliquam lorem, vel mattis nibh tincidunt ac. Suspendisse ac nibh sit amet lacus ullamcorper maximus.</p>
                            </v-flex>
                            <v-flex>
                                <div class="headline mt-3 brown--text font-weight-bold">Lorem ipsum</div>
                                <p class="subheading mt-3">Nullam nec massa eu est fringilla lobortis. Praesent in enim in justo blandit varius. Cras placerat arcu in sapien rhoncus aliquet. Sed interdum tortor et tincidunt condimentum. Etiam consequat mi leo, in suscipit odio scelerisque molestie. Nam et purus consequat, iaculis augue vel, sagittis ligula. Vestibulum aliquet vulputate erat. Phasellus id mauris mauris. Nunc a maximus dolor. Curabitur ut vestibulum arcu. Curabitur non lacus justo. Cras varius a magna in semper. Nulla eros ante, consectetur faucibus sapien eu, rhoncus imperdiet dui. Sed viverra iaculis nunc, id pulvinar massa egestas vitae.</p>
                            </v-flex> -->
                        </v-layout>
                    </v-container>
                </v-container>
                <!--end contato section-->


                


                

                

                
                

            </div><!--end main content inner-->
            
        </div>
        <!--end main container -->        
</template>

<!-- custom script -->
<!--script src="../../assets/site/js/scripts.js" defer></script-->

<script>
import Vue from 'vue';
import Site from '@/components/open/Site';

import db from '@/components/firebaseInit';
import firebase,{ storage } from 'firebase';

import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

// import VueFacebookPixel from 'vue-facebook-pixel'
 
// Vue.use(VueFacebookPixel);

// Vue.analytics.fbq.init('3438569599511916', {
//   em: 'thiagochagas.digital@gmail.com'
// })
// import vueSmoothScroll from 'vue2-smooth-scroll'
// Vue.use(vueSmoothScroll)

import img1 from '../../assets/site/img/arte-destaques-smart-home.jpg';
import img2 from '../../assets/site/img/arte-destaques-grand-home.jpg';
import img3 from '../../assets/img3.jpeg';
import img1_ from '../../assets/img1.jpeg';
import img4 from '../../assets/site/img/parque-global/destaque-home/destaque-parque-global.jpg';
import img5 from '../../assets/site/img/living-villaggio-tatuape/destaque-home/destaque.jpg';
import img6 from '../../assets/site/img/living-heredita-alto-do-ipiranga/destaque-home/destaque.jpg';
import img7 from '../../assets/site/img/lasar-chacara-klabin/destaque-home/destaque.jpg';

import vueMask from 'vue-jquery-mask';

import axios from 'axios'

export default {
    name: 'cadsite',
    metaInfo: {
      title: 'Bertone Broker Imóveis',
    //   meta: [
    //     { charset: 'utf-8' },
    //     { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    //   ]
        meta: [
           { vmid: 'description', name: 'description', content: 'Imóveis em São Paulo de alto padrão' },
           { name: 'og:url', content: 'https://www.bertonebroker.com.br' },
           { name: 'og:title', content: 'Bertone Broker Imóveis' },
           //{ name: 'og:image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg' }
           //$('head').append('<meta property="og:type" content="profile"/>'); 
            //$('head').append('<meta property="og:url" content=""/>');
            //$('head').append("<meta property='og:title' content="+text+"'/>");
            //$('head').append("<meta property='og:image' content="+imageUrl+"'/>");
        ]
        
    },
    data() {
        return {
            nome: '',
            telefone: '',
            email: '',
            periodo: '',
            paginaEntrada: window.location.href,
            img1: img1,
            img2: img2,
            img3: img3,
            img1_: img1_,
            img4: img4,
            img5: img5,
            img6: img6,
            img7: img7,
            mask: "(##) #####-####",
            phone: "4140028922"
        };
    },
    components: {
        Site,
        vueMask
    },
    methods: {
        selectPeriodo(event) {
            //this.menu = false;
            //this.menu2 = false;
            this.periodo = event.target.value
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        enviarDados(){

            // trecho 1 de 2 do código da API do Facebook
            var SHAnome = this.nome;
            var SHAemail = this.email;
            var SHAtelefone = this.telefone

            async function digestMessage(message) {
                const msgUint8 = new TextEncoder().encode(message);                           // encode as (utf-8) Uint8Array
                const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
                const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
                const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
                return hashHex;
            }

            digestMessage(SHAnome)
            .then(digestHex => SHAnome = digestHex);

            digestMessage(SHAemail)
            .then(digestHex => SHAemail = digestHex);

            digestMessage(SHAtelefone)
            .then(digestHex => SHAtelefone = digestHex);
            // .then(digestHex => console.log(digestHex));

            $('.loading').show();
            if(this.nome == "" || this.telefone == "" || this.email == "" || this.periodo == ""){
                $('.loading').hide();
                alert("Por favor, preencha todos os campos!");
                gtag('event', 'enviou_formulario', {
                    'event_category': window.location.href,
                    'event_label': 'Erro validação de dados'//,
                    //'value': '<value>'
                });
            }
            else{
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second
                db.collection('contatos').add({
                    customtimestamp: customtimestamp,
                    nome: day,
                    mes: month,
                    ano: year,
                    nome: this.nome,
                    email: this.email,
                    telefone: this.telefone,
                    paginaEntrada: this.paginaEntrada
                    
                })
                .then(docRef => {
                    console.log('Document written with ID: ', docRef.id);
                    // alert("Formulário enviado com sucesso. Entraremos em contato em breve!");
                    
                    $(".custom-modal").show();
                    $('.loading').hide();

                    fbq('track', 'Lead');

                    gtag('event', 'enviou_formulario', {
                        'event_category': window.location.href,
                        'event_label': 'sucesso'//,
                        //'value': '<value>'
                    });
                    
                })
                .catch(function (error) {
                    console.log('Error adding document: ', error);
                    gtag('event', 'enviou_formulario', {
                        'event_category': window.location.href,
                        'event_label': 'erro para salvar os dados'//,
                        //'value': '<value>'
                    });
                    $('.loading').hide();
                    alert("Ops! Tivemos um probleminha ao enviar os dados do formulário. Por favor, tente novamente!")
                    
                    
                })

                db.collection('CRM').add({
                    customtimestamp: customtimestamp,
                    nome: day,
                    mes: month,
                    ano: year,
                    nome: this.nome,
                    email: this.email,
                    telefone: this.telefone,
                    paginaEntrada: this.paginaEntrada,
                    status: 'Aguardando retorno'
                    
                })
                .then(docRef => {
                    console.log('Document written with ID: ', docRef.id);

                    const slug = this.generateUUID();
                    console.log("slug = " + slug);

                    // trecho 2 de 2 do código da API do Facebook
                    console.log("Dados para a API do Facebook");
                    console.log(SHAnome);
                    console.log(SHAemail);
                    console.log(SHAtelefone);

                    var date = new Date();
                    var eventTime = Math.floor(date.getTime()/1000);

                    var postData = {
                        "data": [
                            {
                                "event_name": "Lead",
                                "event_time": eventTime,
                                "action_source": "website",
                                "event_id": slug,
                                "user_data": {
                                    "em": [
                                        SHAemail
                                    ],
                                    "ph": [
                                        SHAtelefone
                                    ],
                                    "fn": [
                                        SHAnome
                                    ]
                                }
                                // ,
                                // "custom_data": {
                                //     "currency": "USD",
                                //     "value": "142.52"
                                // }
                            }
                        ]
                    }

                    let axiosConfig = {
                        headers: {
                            'Content-Type': 'application/json'//,
                            //"Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                        }
                    };

                    axios.post('https://graph.facebook.com/v11.0/3438569599511916/events?access_token=EAAOQu3vZCLP8BAKHrcsTIKddpnVDM3Ul3f38i4MsSWWwKXFFWLiYlppC2uZCNQLGS6aelQPPvPJmVRpZAfPXWl9mQ1feVuqLLp7abZCRHPmi684eBElVVMXPP3EZAd2ofUsW3yZCA39359naoXqSwvPXwe7T8oAOUTgUWWjG6vqhomEAeZAxQaA', postData, axiosConfig)
                    .then((res) => {
                        console.log("Dados enviados para a API de conversão do Facebook com sucesso!", res);
                    })
                    .catch((err) => {
                        console.log("Erro ao enviar dados para a API de conversão do Facebook ", err);
                    })
                    
                })
                .catch(function (error) {
                    console.log('Error adding document: ', error);
                })

                
            }
            
        }
    }
};




$(document).ready(function(){

    // Vue.analytics.fbq.event('ViewContent', {
    //   content_name: 'Really Fast Running Shoes'
    // })
    //$(".custom-modal-corona").show();
    
    // fechar modal
    $(".fechar, .shadow").click(function(){
        $(".custom-modal").hide();
    })


    // ### Clique para download do app
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', function(event) {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      event.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = event;
    });

    // ### INICIO - para o IOS - Download
    $("#bntAddFnIOS, #bntAddFnIOS2").click(function(){
        $(".custom-modal-ios").show();
        // alert("a");
        // // Detecta se o dispositivo está no iOS
        // const isIos = () => {
        //     const userAgent = window.navigator.userAgent.toLowerCase();
        //     return /iphone|ipad|ipod/.test( userAgent );
        // }
        // // Detects if device is in standalone mode
        // const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        // // Verifica se deve exibir notificação popup de instalação:
        // if (isIos() && !isInStandaloneMode()) {
        //     this.setState({ showInstallMessage: true });
        // }
    })
    // ### FIM - para o IOS


    // // do action when finished install
    // window.addEventListener('appinstalled', e => {
    //     alert("O aplicativo InClass foi instalado com sucesso!")
    //     console.log("success app install!");
    // });


    $(".softo-btn-outline").click(function(){
        window.location.href = "#contact";
    })




    $(".navbar-toggle.collapsed").click(function(){
        if ($('#myNavbar').is(":visible"))
        {
            $("#myNavbar").slideUp('fast');
        }
        else{
            $("#myNavbar").slideDown('fast');
        }
        
    })

    $(".product-counter-section.ptb-40, #features, .promo-section.bg-secondary.ptb-90, #pricing, .testimonial-section.bg-secondary.ptb-90, #faqs").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $("#accordion .panel-heading").click(function(){
        if ($(this).parent().find(".collapse").is(":visible"))
        {
            $(this).parent().find("div.collapse").slideUp();
            $(this).find("h4 a").addClass("collapsed")
            $(this).find("h4 a").removeClass("collapse")
        }
        else{
            $(this).parent().find("div.collapse").slideDown();
            $(this).find("h4 a").removeClass("collapsed")
            $(this).find("h4 a").addClass("collapse")
        }
        
    })

    $("#myNavbar a").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $(".video").click(function(){
        $(".custom-modal").fadeIn("fast");
        $(".custom-modal-ios").hide();
    })

    $(".shadow, .fechar, .content").click(function(){
        $('.video-youtube').each(function(){
            var el_src = $(this).attr("src");
            $(this).attr("src",el_src);
        });
        $(".custom-modal").fadeOut("fast");
    })


    $("a").click(function(){
        gtag('event', 'clicou', {
            'event_category': '/site',
            'event_label': $(this).text()//,
            // 'value': '<value>'
        });
    })

    


// Pixel do Facebook
!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '3438569599511916');
  fbq('track', 'PageView');

  // Evento do facebook - visualizaçao de conteudo    
  //fbq('track', 'ViewContent');
})

</script>
<style scoped>

    #contato{
        padding-bottom: 120px !important;
    }

    ul li {
        list-style-type: circle;
        text-align: left;
    }

    .product-counter-section.ptb-40, #contact{
        background: #fff;
    }

    .btn-icon:hover, .download-btn:hover{
        cursor: pointer;
    }

    .navbar.navbar-default.navbar-fixed-top{
        padding: 3px 0 !important;
    }

    .ti-control-play{
        width:35px !important;
        height: 35px !important;
    }

    .video-play-button a{
        padding-top: 7px !important;
    }

    .custom-modal{
        text-align: center;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 9999;
        top: 0;
        display: none;
    }

    .video-container{
        /*width: 40%;*/
        margin: auto;
        float: none !important;
    }

    .content{
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        padding-top: 25px;
        height: 0;
    }

    .content iframe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
    }

    .fechar{
        position: fixed;
        right: 40px;
        top: 30px;
        color: #fff;
        font-size: 32px;
        z-index: 99999;
        font-weight: 100;
    }
    
    .shadow{
        background: #000;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
        /* IE 8 */
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=80)";

        /* IE 5-7 */
        filter: alpha(opacity=80);

        /* Netscape */
        -moz-opacity: 0.8;

        /* Safari 1.x */
        -khtml-opacity: 0.8;

        /* Good browsers */
        opacity: 0.8;
    }

    .whatsapp{
        position: fixed;
        right: 5px;
        bottom: 5px;
        z-index: 99999999;
    }

    .product-counter-section .counter-list li{
        margin: 0 20px !important;
    }

    .navbar-brand.page-scroll{
        padding-top: 9px
    }

    @-moz-document url-prefix() {
        #video-app {
            height: 470px;
        }
    }

    /* ##################################################
    ##################### Hero ##########################
    ################################################### */

    .home-hero{
        position: relative;
    }

    .redes-sociais{
        position: absolute;
        bottom: 10px;
        right: 0;
        float: right;
        width: auto !important;
    }

    .redes-sociais img{
        width: 25px;
        height: auto;
        margin-right: 10px;
    }

    .link-ancora{
        border: 0;
        padding: 10px;
        color: transparent !important;
    }

    .home-hero {
        background: url('../../assets/destaque-home.jpg');
        background-size: cover;
        width: 100%;
        height: 100%;
        min-height: 500px !important;
        max-height: 560px;
        padding-top: 66px !important;
    }

    .display-4{
        font-size: 62px !important;
        text-shadow:lightsteelblue 0.1em 0.1em 0.2em;
        /*color: #3e2723!important;*/
        /*-webkit-text-stroke-width: 1px; /* largura da borda */
        /*-webkit-text-stroke-color: #d8e6fb; /* cor da borda */
    }

    .display-1 {
        color: #3e2723!important;
        font-size: 20px !important;
    }

    .display-1 span{
        background: #fff;
    }

    @media only screen and (max-width: 600px) {
    .display-4 {
        font-size: 44px !important;
    }

    .pa-5{
            padding: 0 !important
        }
    }

    @media only screen and (max-width: 426px) {
        .display-4 {
            height: auto;
        }
    }

    @media only screen and (max-width: 326px) {
    
        .display-4 {
            font-size: 34px !important;
        }

        .display-1 {
            font-size: 20px !important;
        }
    }

    /* ##################################################
    ################# Lançamentos  ######################
    ################################################### */

    #lancamentos a{
        text-decoration: none !important;
    }

    .headline.mb-0{
        margin-bottom: 12px !important;
    }

    .v-responsive.v-image{
        height: 400px !important;
    }

    /* ##################################################
    #################### Contato ########################
    ################################################### */
    .contact-us-form .form-group .form-control {
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom: 1px solid #f9f9f9;
        border-radius: 0;
        background: #f9f9f9;
        padding: 5px;
    }

    .form-group {
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .form-group input{
        width: 100%;
    }

    .pull-right{
        float: right;
    }

    .qr-code{
        width: 100%;
    }

    .redes-sociais{
        float: right;
    }

    .redes-sociais{
        text-align: center;
        width: 100%;
    }

    .redes-sociais img{
        width: 25px;
        margin: 10px;
    }

    .img-hr{
        float: right;
        width: 100%;
    }

    .telefone{
        text-align: center;
        display: block;
        width: 100%;
    }

    .v-btn{
        position: relative;
        right: -7px;
    }

    .my-5{
        margin-bottom: 10px !important;
        margin-top: 20px !important;
    }

    @media screen and (max-width: 600px) {
        .topnav a {
            float: none;
            width: 100%;
        }

        .somente-desktop{
            display: none;
        }
    }

    @media screen and (min-width: 900px) {
        .meal-plans .v-card {
            min-height: 730px !important;
        }

        #contato .v-card{
            min-height: 398px !important;
        }

        
    }

    .menu-acesso-rapido{
        display: none;
    }

</style>
<style>
   
    html {
       scroll-behavior: smooth;
    }
    
    :target {
        scroll-margin-top: 0.5em;
    }

    .v-image__image{
        background-position: top center !important;
    }
    .v-image__image--cover{
        background-size: cover;
        width: 32%;
    }

    @media screen and (max-width: 600px) {
        .v-image__image--cover{
            background-size: cover;
            width: 100%;
        }
    }
</style>